import 'jquery';
import './vendor/jquery-ui.min.js';

import App from './src/App';

App.init();


// WEBPACK FOOTER //
// ./index.js